// States
import _ from "lodash";
import {store} from "../../store";

const state = {
    requiredConfirmationRoutes: [
        {title:'add-compte-rendu'},
        {title:'add-patient-subscriber'},
        {title:'add-accountant'},
        {title:'add-assistante'},
        {title:'add-prestation'},
        {title:'add-categorie-prestation'},
        {title:'add-consultation-cardiology'},
        {title:'add-drug'},
        {title:'add-prescription'},
        {title:'add-consultation-general'},
        {title:'add-consultation-reason'},
        {title:'add-manager'},
        {title:'add-patient'},
        {title:'add-patient-institution'},
        {title:'add-control-doctor'},
        {title:'add-doctor-institution'},
        {title:'add-practitioner'},
        {title:'add-praticien-institution'},
        {title:'add-subscriber'},
        {title:'add-medical-file'},
        {title:'add-affiliation'},
        {title:'add-reason'},
        {title:'add-profession'},
        {title:'add-specialty'},
        {title:'add-institution'},
        {title:'add-consultation-obstetric'},
        {title:'add-ultrasound'},
        {title:'add-consultation-prenatal'},
        {title:'add-consultation-physical-exam'},
        {title:'add-consultation-complementary-exam'},
        {title:'add-parameter-obstetric'},
        {title:'add-physical-examination'},
        {title:'add-complementary-examination'},
        {title:'add-treatments'},
        {title:'add-hospitalisation'},
        {title:'hospitalisation.add-physical-exam'},
        {title:'hospitalisation.add-complementary-exam'},
        {title:'add-hospitalisation-reason'},
        {title:'add-allergy'},
        {title:'add-antecedent'},
        {title:'add-conclusion'},
        {title:'add-parameter-common'},
        {title:'add-lab-result'},
        {title:'add-imagery-result'},

        {title:'edit-compte-rendu'},
        {title:'edit-consultation-cardiology'},
        {title:'edit-accountant'},
        {title:'edit-prestation'},
        {title:'edit-categorie-prestation'},
        {title:'edit-drug'},
        {title:'edit-prescription'},
        {title:'edit-manager'},
        {title:'edit-patient'},
        {title:'edit-control-doctor'},
        {title:'edit-practitioner'},
        {title:'edit-subscriber'},
        {title:'edit-medical-file'},
        {title:'edit-affiliation'},
        {title:'edit-reason'},
        {title:'edit-profession'},
        {title:'edit-specialty'},
        {title:'edit-institution'},
        {title:'edit-consultation-obstetric'},
        {title:'edit-ultrasound'},
        {title:'edit-consultation-general'},
        {title:'edit-consultation-reason'},
        {title:'edit-consultation-prenatal'},
        {title:'edit-parameter-obstetric'},
        {title:'edit-current-treatment'},
        {title:'edit-hospitalisation'},
        {title:'edit-allergy'},
        {title:'edit-antecedent'},
        {title:'edit-conclusion'},
        {title:'edit-parameter-common'},
        {title:'edit-lab-result'},
        {title:'edit-imagery-result'},
    ],
    breadcrumbItems:[],
};

const getters = {
    requiredConfirmationRoutesList: state => {
        return state.requiredConfirmationRoutes
    },

    breadcrumbItems: state => {
        return state.breadcrumbItems
    },
};
// Actions
const actions = {
    findAndRemove(context, payload) {
    context.commit('findAndRemoveHandler', {  name: payload.name});
},

    addItem(context, payload) {
        context.commit('addItemHandler', { item: payload.item });
    },

    clearBreadcrumbItems(context,payload){
        context.commit('clearItemsHandler', { items: [] });
    },

    dropRightItem(context, payload) {
        context.commit('dropRightItemHandler', { name: payload.name });
    },

     putOnTopItem(context, payload) {
        context.commit('putOnTopItemHandler', { item: payload.item });
    },

};

// Mutations
const mutations = {
    addItemHandler(state, { item }) {
        // Update specialties state
        state.breadcrumbItems.push(item) ;
    },

    clearItemsHandler(state, { items }) {
        // Update specialties state
        state.breadcrumbItems = items ;
    },

    putOnTopItemHandler(state, { item }) {
        // Update specialties state
        if("-1" == (_.findIndex(state.breadcrumbItems,{'title':item.name})) ){
            state.breadcrumbItems.splice((state.breadcrumbItems).length-1,0,item) ;
        }

    },

    dropRightItemHandler(state, { name }) {
        // Update specialties state
        state.breadcrumbItems =  _.dropRightWhile(state.breadcrumbItems, function (item) {
            return item.title != name;
        })
    },

    findAndRemoveHandler(state, { name }) {
        // Update specialties state
        let element = _.findIndex(state.breadcrumbItems,{'title':name});
        if(element != "-1"){
            state.breadcrumbItems.splice(element,1);
        }

    },
}


export default {
    state,
    getters,
    actions,
    mutations
}